<template>
  <v-container fluid fill-heigh>

    <CadastreSeEscolheTipoDialog @onEscolha="escolheuTipo" @onCancela="direcionaTela" v-model="cadastreSeDialogOpenedEscolheTipo"/>
    <CadastreSeCompradorDialog 
      :item="comprador" 
      @onCancela="direcionaTela" 
      titulo="CONECTA PETROSUPPLY - POLOS SEBRAE ONSHORE, OFFSHORE e ABPIP - Cadastro Comprador"
      v-model="cadastreSeDialogOpenedComprador"/>
    <CadastreSeFornecedorDialog 
      :item="fornecedor" 
      @onCancela="direcionaTela" 
      titulo="CONECTA PETROSUPPLY - POLOS SEBRAE ONSHORE, OFFSHORE e ABPIP - Cadastro Fornecedor"
      v-model="cadastreSeDialogOpenedFornecedor"/>

    <v-row align="center" justify="center">
      <v-col cols="auto">
        <v-card class="elevation-0 d-flex justify-center align-center" style="background-color: #F0F2F5; height: calc(100vh - 50px);">
          <v-card-text style="width: 1000px; max-width: 100%;">
            <v-row>
              <v-col cols="12" md="6" class="left-column" v-if="!$vuetify.breakpoint.mobile">
              </v-col> 
              <v-col cols="12" md="6" class="right-column" 
                :class="($vuetify.breakpoint.mobile ? 'borda-toda-redonda' : 'borda-direita-redonda')" >
                <!-- Logo do Sistema --> 
                <img src="../../assets/logo-branca.png" alt="Logo do Sistema" class="logo">
                <!-- Texto Descritivo -->
                <p class="description">Sistema para Geração de Negócios <br>no Segmento de Óleo & Gás</p>
                <!-- Div com Borda Arredondada e Sem Cor de Fundo -->
                <v-row>
                  <v-col cols="12" v-show="exibirOpcaoTipoConta" class="identificacao-conta-box">
                    <h1 class="text-center mb-2">Identificação da Conta</h1>
                    <v-row justify="center">
                      <v-col cols="12" class="pa-0">
                        <v-radio-group v-model="type" row 
                          dense
                          :rules="[
                                  this.$validators.string.required,
                            ]">
                          <v-radio color="#efc00f"
                            value="usuario">
                            <template v-slot:label>
                              <div style="color:white">Usuário</div>
                            </template>
                          </v-radio>
                          <v-radio color="#efc00f"
                            value="fornecedor">
                            <template v-slot:label>
                              <div style="color:white">Fornecedor</div>
                            </template>
                          </v-radio>
                          <v-radio color="#efc00f"
                            label=""
                            value="comprador">
                            <template v-slot:label>
                              <div style="color:white">Comprador</div>
                            </template>
                          </v-radio>
                        </v-radio-group>
                      </v-col>         
                    </v-row>                           
                  </v-col>
                  <!-- form login -->
                  <v-col v-show="formAtivo==='login'" cols="12" class="login-box">
                    <h2 class="text-center mb-4">Dados de acesso</h2>
                    <v-fade-transition>
                      <v-progress-linear v-if="processing" color="#efc00f" indeterminate height="10px"/>
                    </v-fade-transition>                  
                    <v-form ref="form" v-model="valid">
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <v-text-field
                              solo
                              :rules="[
                                this.$validators.string.required,
                                this.$validators.string.notEmpty,
                              ]"
                              :disabled="processing"
                              placeholder="Informe seu login"
                              v-model="login">
                            <template v-slot:append>
                              <div style="color:white;"><v-icon color="#efc00f">mdi-account</v-icon></div>
                            </template>  
                          </v-text-field>
                        </v-col>
                      </v-row>  
                      <v-row>
                        <v-col cols="12" class="pt-0">                           
                          <v-text-field
                              solo
                              :disabled="processing"
                              :placeholder="'Digite sua Senha'"
                              autocomplete="off"
                              v-model="password"
                              @keyup.enter="onEnterClick"
                              :rules="[
                                this.$validators.string.required,
                                this.$validators.string.notEmpty,
                              ]"
                              :type="showPassword ? 'text' : 'password'">
                            <template v-slot:append>
                              <div style="color:white;">
                                <v-icon @click="showPassword = !showPassword" color="#efc00f">{{showPassword ? 'mdi-eye-off' : 'mdi-eye'}}</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </v-col>         
                      </v-row>                          
                    </v-form>
                    <v-btn class="btn-primary" @click="onEnterClick" :disabled="processing || !valid" block large>Entrar</v-btn>
                    <div v-if="type !== 'usuario'" style="text-align: center; margin-top: 1rem;">
                      <a @click.prevent="direcionaTela('cadastreSe')" class="forgot-password">Quero me cadastrar</a>
                       | 
                      <a @click.prevent="direcionaTela('eventos')" class="forgot-password">Nossos Eventos</a>
                    </div>
                  </v-col>
                  <!-- esqueci Senha -->
                  <v-col v-show="formAtivo==='esqueciSenha'" cols="12" class="login-box">
                    <h2 class="text-center mb-4">Esqueci a Senha</h2>
                    <v-fade-transition>
                      <v-progress-linear v-if="processing" color="#efc00f" indeterminate height="10px"/>
                    </v-fade-transition>
                    <v-form ref="formEsqueciSenha" v-model="validEsqueciSenha">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                              solo
                              :rules="[
                                this.$validators.string.required,
                                this.$validators.string.email,
                                this.$validators.string.notEmpty,
                              ]"
                              :disabled="processing"
                              placeholder="Informe seu email"
                              v-model="email">
                            <template v-slot:append>
                              <div style="color:white;"><v-icon color="#5246CB">mdi-at</v-icon></div>
                            </template>  
                          </v-text-field>
                        </v-col>
                      </v-row>                   
                    </v-form>
                    <v-btn class="btn-primary" @click="enviarSolicitacaoNovaSenha" :disabled="processing || !validEsqueciSenha" block large>Solicitar Nova Senha</v-btn>
                  </v-col>
                  <!-- Form de confirmação -->
                  <v-col v-show="formAtivo==='confSenha'" cols="12" class="login-box">
                    <h2 class="text-center mb-4">Solicitação de nova Senha</h2>
                    <v-fade-transition>
                      <v-progress-linear v-if="processing" color="#efc00f" indeterminate height="10px"/>
                    </v-fade-transition>
                    <v-form ref="formConfirmarSolicitacao">
                      <v-row>
                        <v-col cols="12">
                          <div v-if="controleChaveValida === 'S'" class="instructions-box">
                            <h4><v-icon color="success">mdi-check-circle-outline</v-icon> Leia antes de confirmar:</h4>
                            <p>Ao confirmar esta solicitação, uma nova senha será gerada automaticamente e enviada para o e-mail cadastrado.</p>
                            <p>No seu próximo login, você precisará definir uma nova senha pessoal para continuar utilizando o sistema.</p>
                            <p>Se estiver de acordo, clique no botão abaixo para confirmar a mudança.</p>
                          </div>
                          <div v-else-if="controleChaveValida === 'N'" class="instructions-box">
                            <h4><v-icon color="error">mdi-alert-circle-outline</v-icon> Atenção:</h4>
                            <p>{{msgRetornoValidacao}}</p>
                            <p><a @click.prevent="direcionaTela('login')" class="forgot-password">Ir para login</a></p>
                          </div>
                        </v-col>
                      </v-row>  
                    </v-form>
                    <v-btn class="btn-primary" @click="confirmarSolicitacao" :disabled="processing || controleChaveValida !== 'S'" block large>Confirmar mudança de senha</v-btn>                    
                  </v-col>                  
                </v-row>
                <v-row>
                  <v-col cols="12" center>
                    <a v-if="formAtivo === 'login'" @click.prevent="direcionaTela('esqueciSenha')" class="forgot-password">Esqueceu a senha?</a>
	                  <a v-if="exibirIrProLogin" @click.prevent="direcionaTela('login')" class="forgot-password">Ir para login</a>
                    <div class="versao">Versão: {{appVersion}} </div>
                  </v-col>
                </v-row>                           
                <v-row no-gutters>
                  <v-col cols="12" class="logos-apoio pa-2">
                    <!-- Logo SEBRAE --> 
                    <img src="../../assets/SEBRAE-branca.png" alt="Logo do SEBRAE" class="logo-sebrae">
                    <!-- Logo ABPIP --> 
                    <img src="../../assets/ABPIP-branca.png" alt="Logo da ABPIP" class="logo-abpip">
                  </v-col>
                </v-row>                           
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppLogo from "../../components/app/AppLogo";
import {ApiError} from "../../api/core";
import CadastreSeFornecedorDialog from "../Fornecedor/CadastreSeFornecedorDialog";
import CadastreSeCompradorDialog from "../Comprador/CadastreSeCompradorDialog";
import CadastreSeEscolheTipoDialog from "./CadastreSeEscolheTipoDialog";
import {solicitarNovaSenha, validaSolicitacaoNovaSenha, confirmarSolicitacaoNovaSenha} from "../../api/alterarSenha";

export default {
  components: {AppLogo, CadastreSeFornecedorDialog, CadastreSeCompradorDialog, CadastreSeEscolheTipoDialog},
  name: "Login",
  props: {
    formAtivo: {
      type: String,
      required: true,
      default: 'login',
    },
  },
  data() {
    return {
      appVersion: PACKAGE_VERSION,
      type: 'usuario',
      valid: false,
      validEsqueciSenha: false,
      login: '',
      password: '',
      email: null,
      showPassword: false,
      processing: false,
      controleChaveValida: 'P',
      msgRetornoValidacao: '',
      //dialogs do cadastre-se
      comprador: {
        id: null,
        idAtividadeEconomica: null,
        descricaoAtividadeEconomica: "",
        nomeFantasia: "",
        razaoSocial: "",
        descricao: "",
        flgEmpresaEstrangeira: "N",
        cnpj: "",
        senha: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        cep: "",
        pais: "",
        telefone: "",
        email: "",
        siteRede: "",
        contatos: [],
        contatosParaCadastro: "",       
      },
      cadastreSeDialogOpenedComprador: false,
      fornecedor: {
        id: null,
        idSetor: null,
        descricaoSetor: "",
        idPorte: null,
        descricaoPorte: "",
        idRamoAtuacao: null,
        descricaoRamoAtuacao: "",
        nomeFantasia: "",
        razaoSocial: "",
        descricao: "",
        flgEmpresaEstrangeira: "N",
        cnpj: "",
        senha: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        cep: "",
        pais: "",
        telefone: "",
        email: "",
        siteRede: "",
        contatos: [],
        ofertas: [],
        ofertasParaCadastro: "",
        contatosParaCadastro: "",
      },
      cadastreSeDialogOpenedFornecedor: false,
      cadastreSeDialogOpenedEscolheTipo: false,
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'token', 'isAuthenticated']),
    chaveConfSenha() {
      return this.$route.params.chave;
    },
    exibirOpcaoTipoConta(){
      return this.formAtivo === '' || this.formAtivo === 'login' || this.formAtivo === 'esqueciSenha';
    },
    exibirIrProLogin(){
      return this.formAtivo === 'esqueciSenha' || this.formAtivo === 'confSenha';
    }
  },
  methods: {
    ...mapActions('auth', ['doLogin']),
    async onEnterClick() {
      if(!this.$refs.form.validate()) return;
      try {
        this.processing = true;

        await new Promise((resolve) => {
          setTimeout(() => resolve(), 1000);
        })
        
        await this.doLogin({
          type: this.type,
          login: this.login,
          password: this.password
        });

      } catch (err) {
        if (err instanceof ApiError) {
          if (err.message==="duplicado"){
            this.$toast.error(`Mais de um Cliente encontrado com as credencias fornecidas. Entre em contato com a administração!`, {
              timeout: 6000
            })
          } else {
            this.$toast.error(err.message, {
              timeout: 6000
            })
          }
        } else {
          this.$toast.error(`Não foi possível efetuar o login. Entre em contato com a administração!`, {
            timeout: 6000
          })
        }
      } finally {
        this.processing = false;
      }
    },
    escolheuTipo(tipo){
      console.log(tipo)
      this.type = tipo;
      this.direcionaTela('cadastreSe');
    },
    direcionaTela(form) {
      if (form === 'login') {
        this.cadastreSeDialogOpenedComprador = false;
        this.cadastreSeDialogOpenedFornecedor = false;
        this.cadastreSeDialogOpenedEscolheTipo = false;
        this.$router.push({
          name: 'Login'
        });
      } else if (form === 'eventos') {
        this.$router.push({
          name: 'NossosEventos',
          query: {
            tipoContaSelecionado: this.type
          }
        });
      } else if (form === 'esqueciSenha') {
        this.$router.push({
          name: 'EsqueciSenha'
        });
      } else if (form === 'cadastreSe') {
        if (this.type === 'fornecedor') {
          this.cadastreSeDialogOpenedFornecedor = true;
        } else if (this.type === 'comprador') {
          this.cadastreSeDialogOpenedComprador = true;
        } else {
          this.cadastreSeDialogOpenedEscolheTipo = true;
        }
      } 
    },
    async enviarSolicitacaoNovaSenha() {
      if(!this.$refs.formEsqueciSenha.validate()) return;
      try {
        this.processing = true;
        const retornoSolicitacao = await solicitarNovaSenha({
          tipo: this.type,
          email: this.email
        });
        this.$swal({
          title: 'Sucesso',
          html: retornoSolicitacao.msg,
          icon: 'success',
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,          
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
            this.direcionaTela('login');
          }
        });
      } catch (err) {
        let menssagemErro = '';
        if (err instanceof ApiError) {
          menssagemErro = err.message;
        } else {
          menssagemErro = `Ocorreu algum erro ao tentar solicitar uma nova senha. Entre em contato com a administração! ${err}`;
        }
        this.$swal({
          title: 'Ocorreu um erro',
          html: menssagemErro,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok'
        });
      } finally {
        this.processing = false;
      }
    },
    async validarChave() {
      if (this.formAtivo === 'cadastreSe') {
        this.cadastreSeDialogOpenedEscolheTipo = true;
      };
      if (this.formAtivo !== 'confSenha') return;
      try {
        this.processing = true;
        const retornoValidacao = await validaSolicitacaoNovaSenha({
          ch: this.chaveConfSenha
        });
        this.controleChaveValida = (retornoValidacao?.success ? 'S' : 'N');
      } catch (err) {
        this.controleChaveValida = 'N';
        if (err instanceof ApiError) {
          this.msgRetornoValidacao = err.message;
        } else {
          this.msgRetornoValidacao = `Ocorreu algum erro ao tentar validar sua solicitação de nova senha. Entre em contato com a administração!`;
        }
      } finally {
        this.processing = false;
      }
    },
    async confirmarSolicitacao() {
      try {
        this.processing = true;
        const retornoConfirmacao = await confirmarSolicitacaoNovaSenha({
          ch: this.chaveConfSenha
        });
        this.$swal({
          title: 'Sucesso',
          html: retornoConfirmacao.msg,
          icon: 'success',
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,          
          confirmButtonText: 'Ok'
        }).then((result) => {
          if (result.isConfirmed) {
            this.direcionaTela('login');
          }
        });
      } catch (err) {
        let menssagemErro = '';
        if (err instanceof ApiError) {
          menssagemErro = err.message;
        } else {
          menssagemErro = `Ocorreu algum erro ao tentar confirmar sua nova senha. Entre em contato com a administração!`;
        }
        this.$swal({
          title: 'Ocorreu um erro',
          html: menssagemErro,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Ok'
        });
      } finally {
        this.processing = false;
      }
    },
  },
  mounted(){
    this.validarChave();
  }
}
</script>

<style scoped lang="scss">
  .left-column {
      background-image: url('../../assets/backgrounds/bg-card-login.jpg');
      background-size: cover;
      background-position: center;
      border-radius: 15px 0 0 15px;
  }
  .right-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background-color: #167ABC;
    color: #ffffff;
  }
  .borda-direita-redonda {
    border-radius: 0 15px 15px 0;
  }
  .borda-toda-redonda {
    border-radius: 15px;
  }

  .logo {
    width: 200px;
    height: auto;
    margin-bottom: 1rem;
  }
  .logo-sebrae {
    width: 100px;
    height: auto;
    padding: 5px;
  }
  .logo-abpip {
    width: 150px;
    height: auto;
    padding: 5px;
  }

  .description {
    font-size: 1.1rem;
    text-align: center;
    margin-bottom: 2rem;
  }

  .identificacao-conta-box {
    padding: 1rem;
    text-align: center;
    width: 100%;
    background-color: transparent;
  }

  .identificacao-conta-box ::v-deep .v-input--radio-group__input {
    justify-content: center;
  }

  .login-box {
    padding: 1.5rem 2rem;
    border-radius: 15px;
    width: 100%;
    border: 1px solid #3F91C7;
    background-color: transparent;
  }

  .login-box .form-control {
    background-color: #f8f9fa;
    color: #000000;
  } 

  .login-box .btn-primary {
    background-color: #EFC00F !important;
    color: #ffffff !important;
    border: none;
  }

  .login-box .btn-primary:hover {
    background-color: #2EAB66 !important;
  }

  .forgot-password {
    color: #ffffff;
  }
  .mobile-scroll {
    overflow-y: auto;
  }
  .versao {
    font-size: 0.7rem;
    text-align: center;
  }
  .logos-apoio {
    font-size: 0.7rem;
    text-align: center;
  }

  /*INPUTS*/
  ::v-deep .v-input__control .v-input__slot .v-text-field__slot input {
    background-color: #ffffff !important;
  }

  .instructions-box {
    background-color: #f8f9fa;
    padding: 1.5rem;
    font-size: 1rem;
    color: #333333;
    line-height: 1.6;
    border-radius: 8px;
    border: 1px solid #dcdcdc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 1rem;
  }

  .instructions-box h4 {
    margin-bottom: 1rem;
    color: #5246cb;
    font-size: 1rem;
  }

  .instructions-box p {
    margin: 0.5rem 0;
  }

  .instructions-box b {
    color: #5246cb;
  }
</style>